<template>
  <div class="win" >
    <!-- 背景比例 750*645  -->
    <div class="main" :style="'background-image:url('+oss+data.style.backgroundImage+')'">
        <div class="tips" :style="'color:'+data.style.color">
          {{data.params.tips}}
          <p>20 <span>积分</span></p>
        </div>
    </div> 
  </div>
</template>
<script>
import config from "@/config";
export default {
  name: "double",
  props: { data: Object },
  setup() {
    const oss = config.oss[process.env.VUE_APP_type];
    return {
      oss,
    };
  },
};
</script>

<style lang="less" scoped>
.win {
  position: relative;
  .main {
    width: 100%;
    margin: 0 auto;
    height: 322.5px;
    color: #ef8537;
    font-size: 15px;
    background-repeat: no-repeat;
    background-size: contain;
    position: relative;
    background-position:center;
    .tips{
      font-size: 26px;
      text-align: center;
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translate(-50%,-50%);
      width:55%;
      line-height: 1.2;
      p{
          font-size:40px ;
          line-height: 1;
          margin-top: 10px;
          span{
            font-size: 26px;
          }
      }
    }
  }
}
</style>